import React, { useState, useEffect, useMemo } from "react";
import Source from "./Source";
import Sidebar from "./Sidebar.js";
import ItemType from "./pages/Items/ItemType.js";
import Items from "./pages/Items/Items.js";
import Stock from "./pages/Items/Stock.js";
import Purchase from "./pages/Items/Purchase.js";
import AllTransactions from "./pages/Transactions/AllTransactions.js";
import Sell from "./pages/Items/Sell.js";
import Dashboard from "./pages/Dashboard";
import Account from "./pages/Account";
import Money from "./pages/Money";
import Setting from "./pages/Setting.js";
import Withdraw from "./pages/Withdraw.js";
import Deposite from "./pages/Deposite.js";
import ReportCustomers from "./pages/Report/ReportCustomers.js";
import Cach from "./pages/Cach.js";
import DraftTransaction from "./pages/Draft/DraftTransaction.js";
import Manage from "./pages/Manage";
import Profile from "./pages/Profile";
import Accountp from "./assets/icon/accountp.png";
import af from "./assets/icon/afghanistan.png";
import en from "./assets/icon/ENGLISH.png";
import NotFound from "./NotFound.js";
import Language from "./assets/icon/language.png";
import axios from "axios";
import Swal from "sweetalert2";
import { useCollapse } from "react-collapsed";
// import useCollapse from "./usecollapse.js";
import Setting_pic from "./assets/icon/settings.png";
import Customer_pic from "./assets/icon/customers_pic.png";
import Deposite_pic from "./assets/icon/deposite.png";
import Withdraw_pic from "./assets/icon/withdraw.png";
import ReportPic from "./assets/icon/report.png";
import DraftCustomers from "./pages/Draft/DraftCustomers.js";
import DraftAccount from "./pages/Draft/DraftAccount.js";
// import DraftTransaction from "./assets/icon/DraftTransaction.png";
import DraftMoney from "./pages/Draft/DraftMoney.js";
import Cash_pic from "./assets/icon/money.png";
import Down from "./assets/icon/down.png";
import Menu from "./assets/icon/menuu.png";
import Business from "./assets/icon/Business.png";
import Logout from "./assets/icon/logout.png";
import Manager from "./assets/icon/manager.png";
import MoneyPic from "./assets/icon/money.png";
import DashboardPic from "./assets/icon/dashboard.png";
import Wellcom from "./pages/forms/Wellcom";
import AccountPic from "./assets/icon/accounts.png";
import Customers from "./pages/Customers.js";
import Transformation from "./pages/Transformations/Transformations.js";
import Draft_pic from "./assets/icon/draft.png";
import Change from "./assets/icon/changepass.png";
import expand from "./assets/icon/down.png";
import alldraft from "./assets/icon/alldraft.png";
import ThirdDeptDtable from "./pages/ThirdDeptDtable.js";
import "../src/App.css";
import Loading from "./Loading.js";
import { MyProvider } from "./pages/constext/UseContext.js";
import { useSelector, useDispatch } from "react-redux";
import {
  getSettings,
  updateSettingInCache,
} from "./pages/Redux/settingSlice.js";
import { getItems } from "./pages/Redux/itemSlice.js";
import { getCustomers } from "./pages/Redux/customerSlice.js";
import { getMoneys } from "./pages/Redux/moneysSlice.js";
import { getBelances } from "./pages/Redux/belanceSlice.js";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import PurchaseReturn from "./pages/Items/Returns/PurchaseRetrun.js";
import SellRetrun from "./pages/Items/Returns/SellReturn.js";
import BenefitReport from "./pages/Report/BenefitReport.js";
import { FormattedMessage } from "react-intl";
import SidebarPa from "./sidebarPa.js";
import { useShowAlert } from "./warrper.js";
import Sideoption from "./pages/SideOption/Sideoption.js";
import { toBePartiallyChecked } from "@testing-library/jest-dom/matchers.js";
import Debite from "./pages/Report/Debite.js";
import Credit from "./pages/Report/Credit.js";
import Expenses from "./pages/Expense/Expenses.js";
import DraftExpenses from "./pages/Draft/DraftExpense.js";
import SewingOrder from "./pages/Toiloring/SewingOrder.js";
import DraftSewing from "./pages/Draft/DraftSewing.js";
import BenefitSewing from "./pages/Report/BenefitSewing.js";
import OwnAssets from "./pages/Report/OwnAssets.js";
import ComplateOrder from "./pages/Toiloring/ComplateOrder.js";
import Surrendered from "./pages/Toiloring/Surrndered.js";

// import { createPopper } from '@popperjs/core';

// import Setting from "./pages/Setting.js";

function App1({
  setCorrect,
  setError,
  loguser,
  setLoguser,
  type,
  Collapse,
  setCollapse,
  username,
  password,
  // setting,
}) {
  const showAlert = useShowAlert();
  const dispatch = useDispatch();
  const { settings, errors, statuss } = useSelector((state) => state.settings);
  const [setting, setsettings] = useState([{ date: "", language: "" }]);
  // dispatch(getItems());
  // dispatch(getCustomers());
  // dispatch(getMoneys());
  // dispatch(getBelances());
  // useEffect(() => {
  //   // بررسی و بارگذاری `belances`
  //   // console.log(statuss);
  //   if (!statuss) {
  //     // console.log(statuss);
  //     dispatch(getSettings());
  //   }else if (statuss === 'succeeded') {
  //     setsettings(settings);
  //   }

  //   // // بررسی و بارگذاری `moneys`
  //   // if (statusm === 'idle' && !moneys) {
  //   //   dispatch(getMoneys());
  //   // }

  //   // // بررسی و بارگذاری `customers`
  //   // if (statusc === 'idle' && !customers) {
  //   //   dispatch(getCustomers());
  //   // }
  // }, [dispatch, statuss, settings]);
  // useEffect(() => {
  //   const refreshAccessToken = async () => {
  //     const refreshToken = localStorage.getItem('refresh');
  //     if (!refreshToken) {
  //       console.error("No refresh token found");
  //       return;
  //     }

  //     try {
  //       const response = await axios.post(Source.getAddress() + '/api/token/refresh/', {
  //         refresh: refreshToken,
  //       });
  //       const newAccessToken = response.data.access;
  //       localStorage.setItem('access', newAccessToken);
  //       console.log(newAccessToken);
  //     } catch (error) {
  //       console.error("Error refreshing access token:", error);
  //     }
  //   };

  //   // Check if access token is present and valid before making requests
  //   const token = localStorage.getItem('access');
  //   if (!token) {
  //     refreshAccessToken();
  //   } else {
  //     // Here you can also add a function to verify the token validity, if needed
  //   }
  // }, []);

  // console.log(setting);
  const [money, setMoney] = useState([]);
  const [date, setdate] = useState("Hejiri Date");
  // console.log(password);

  const [deposite, setdeposite] = useState([]);
  const [withdraw, setwithdraw] = useState([]);
  const [alltransactions, setalltransactions] = useState([]);
  const [draft, setdraft] = useState([]);
  const [Cash, setCash] = useState([]);
  const [user, setuser] = useState([]);
  // for cach report is
  const [totals, setTotals] = useState({});
  useEffect(() => {
    const fetchTotalRecords = async () => {
      const newTotals = {};
      let moneyid;
      for (const record of money) {
        try {
          const res = await axios.get(
            Source.getAddress() + "/api/reports/sum_by_money_type",
            {
              params: {
                moneytype: record.id,
              },
              headers: {
                Authorization: `Bearer ${localStorage.getItem("access")}`,
              },
            }
          );
          moneyid = record.id;
          newTotals[record.id] = res.data.total_amount;
          console.log(newTotals);
        } catch (err) {
          console.error("Error getting report:", err);
        }
      }
      setTotals(newTotals);
    };
    fetchTotalRecords();
  }, [money]);

  const [loading, setLoading] = useState(false);

  const [belance, setbelance] = useState([]);

  const [accounts, setAccounts] = useState([]);

  const [users, setUsers] = useState([]);

  const handleLogout = () => {
    // localStorage.removeItem('sidebar');
    localStorage.removeItem("userToken");
    localStorage.removeItem("access");
    localStorage.removeItem("userTokenname");
    localStorage.removeItem("userTokenid");
    localStorage.removeItem("userToken");
    localStorage.clear();
    setError(false);
    setCorrect(false);
  };
  const [records, setRecords] = useState(accounts);
  const [isToggled, setIsToggled] = useState(localStorage.getItem('toggle') === 'true');
// console.log(localStorage.getItem('toggle'))
  const handleToggle = () => {
    const newValue = !isToggled;
    localStorage.setItem("toggle", String(newValue));  // Explicitly convert to string
    setIsToggled(newValue);
  };
  const [typemoney, settypemoney] = useState();
  let Component;
  switch (window.location.pathname) {
    case "/account":
      Component = (
        <Account
          loading={loading}
          setLoading={setLoading}
          accounts={belance}
          money={money}
          customers={accounts}
          setAccounts={setAccounts}
          user={user}
          settings={setting}
          setsettings={setsettings}
        />
      );
      break;
    case "/transformations":
      Component = (
        <Transformation
          loading={loading}
          setLoading={setLoading}
          money={money}
          accounts={accounts}
          setAccounts={setAccounts}
          withdraw={withdraw}
          belance={belance}
          setbelance={setbelance}
          user={user}
          Cash={Cash}
          setCash={setCash}
          settings={setting}
          setsettings={setsettings}
        />
      );
      break;
    case "/withdraw":
      Component = (
        <Withdraw
          loading={loading}
          setLoading={setLoading}
          money={money}
          accounts={accounts}
          setAccounts={setAccounts}
          withdraw={withdraw}
          belance={belance}
          setbelance={setbelance}
          user={user}
          Cash={Cash}
          setCash={setCash}
          settings={setting}
          setsettings={setsettings}
        />
      );
      break;
    case "/deposite":
      Component = (
        <Deposite
          loading={loading}
          setLoading={setLoading}
          money={money}
          accounts={accounts}
          setAccounts={setAccounts}
          deposite={deposite}
          setbelance={setbelance}
          belance={belance}
          user={user}
          Cash={Cash}
          setCash={setCash}
          settings={setting}
          setsettings={setsettings}
        />
      );
      break;
    case "/alltransactions":
      Component = (
        <AllTransactions
          loading={loading}
          setLoading={setLoading}
          money={money}
          accounts={accounts}
          setAccounts={setAccounts}
          deposite={alltransactions}
          setbelance={setbelance}
          belance={belance}
          user={user}
          Cash={Cash}
          setCash={setCash}
          settings={setting}
          setsettings={setsettings}
        />
      );
      break;
    case "/cach/report":
      Component = (
        <ThirdDeptDtable
          money={money}
          setMoney={setMoney}
          loading={loading}
          setLoading={setLoading}
          typemoney={typemoney}
          settypemoney={settypemoney}
          deposite={deposite}
          setbelance={setbelance}
          belance={belance}
          user={user}
          Cash={Cash}
          setCash={setCash}
          settings={setting}
          setsettings={setsettings}
          accounts={accounts}
          setAccounts={setAccounts}
        />
      );
      break;
    case "/drafttransactions":
      Component = (
        <DraftTransaction
          loading={loading}
          setLoading={setLoading}
          withdraw={draft}
          belance={belance}
          Cash={Cash}
          user={user}
          setCash={setCash}
          settings={setting}
          setsettings={setsettings}
        />
      );
      break;
    case "/":
      Component = <Dashboard />;
      break;
    case "/money_type":
      Component = (
        <Money
          loading={loading}
          setLoading={setLoading}
          money={money}
          setMoney={setMoney}
          belance={belance}
          user={user}
          settings={setting}
        />
      );
      break;
    case "/setting":
      Component = (
        <Setting
          loading={loading}
          setLoading={setLoading}
          money={money}
          belance={belance}
          setMoney={setMoney}
          user={user}
          date1={date}
          setdate={setdate}
          username={username}
          // settings={setting}
          setsettings={setsettings}
        />
      );
      break;
    case "/profile":
      Component = (
        <Profile
          loading={loading}
          setLoading={setLoading}
          loguser={loguser}
          setLoguser={setLoguser}
          settings={setting}
          setsettings={setsettings}
        />
      );
      break;
    case "/cash":
      Component = (
        <Cach
          loading={loading}
          setLoading={setLoading}
          // fetchTotalRecords={fetchTotalRecords}
          totals={totals}
          setTotals={setTotals}
          money={money}
          setMoney1={setMoney}
          setLoguser={setLoguser}
          settings={setting}
          setsettings={setsettings}
        />
      );
      break;
    // case "/":
    //   Component = <Wellcom settings={settings} setsettings={setsettings} />;
    //   break;
    case "/manage":
      if (localStorage.getItem("userTokenname") === "admin") {
        Component = (
          <Manage
            loading={loading}
            setLoading={setLoading}
            users={users}
            // deleteItem={deleteItem}
            setUsers={setUsers}
            settings={setting}
            setsettings={setsettings}
          />
        );
      }
      break;
    case "/customers":
      // if (type === "admin") {
      Component = (
        <Customers
          money={money}
          loading={loading}
          setLoading={setLoading}
          accounts={accounts}
          setAccounts={setAccounts}
          date={date}
          user={user}
          setting={setting}
          setsetting={setsettings}
          belance={belance}
          setbelance={setbelance}
        />
      );
      // }
      break;
    case "/draftcustomer":
      Component = (
        <DraftCustomers
          money={money}
          loading={loading}
          setLoading={setLoading}
          accounts={accounts}
          setAccounts={setAccounts}
          date={date}
          user={user}
          settings={setting}
          setsettings={setsettings}
          belance={belance}
          setbelance={setbelance}
        />
      );
      break;
    case "/draftmoney":
      Component = (
        <DraftMoney
          loading={loading}
          setLoading={setLoading}
          money={money}
          setMoney={setMoney}
          belance={belance}
          user={user}
          settings={setting}
        />
      );
      break;
    case "/draftaccount":
      Component = (
        <DraftAccount
          loading={loading}
          setLoading={setLoading}
          accounts={belance}
          money={money}
          customers={accounts}
          setAccounts={setAccounts}
          user={user}
          settings={setting}
          setsettings={setsettings}
        />
      );
      break;
    case "/customerreport":
      Component = (
        <ReportCustomers
          Customers={accounts}
          // settings={settings}
        />
      );
      break;
    case "/itemtype":
      Component = <ItemType />;
      break;
    case "/items":
      Component = <Items />;
      break;
    case "/stock":
      Component = <Stock />;
      break;
    case "/purchase":
      Component = <Purchase />;
      break;
    case "/sell":
      Component = <Sell />;
      break;
    case "/sellreturn":
      Component = <SellRetrun />;
      break;
    case "/purchasereturn":
      Component = <PurchaseReturn />;
      break;
    case "/benefitreport":
      Component = <BenefitReport />;
      break;
      case "/owneassests":
      Component = <OwnAssets />;
      break;
      case "/benefitsewing":
      Component = <BenefitSewing />;
      break;
      case "/debit":
      Component = <Debite/>;
      break;
      case "/credit":
      Component = <Credit/>;
      break;
      case "/expense":
      Component = <Expenses/>;
      break;
      case "/draftexpense":
      Component = <DraftExpenses/>;
      break;
      case "/draftsewing":
      Component = <DraftSewing/>;
      break;
      case "/sewingorder":
      Component = <SewingOrder/>;
      break;
      case "/complete":
      Component = <ComplateOrder/>;
      break;
      case "/surrendered":
      Component = <Surrendered/>;
      break;
      case "/1469sideoption":
        Component = <Sideoption />;
        break;
        default :
        Component = <NotFound />;
        break;
  }

  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

  const columns = useMemo(() => {
    if (isDesktop) {
      setIsToggled(false);
    } else {
      setIsToggled(true);
    }
    return;
  }, [isDesktop]);
  const styles = {
    spinnerContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      width: "100vw",
      position: "fixed",
      // top: -60rem;
      // left: 50%
      /* opacity: 0.1; */
      transform: "translateX(-50%)",
      width: "300px",
      padding: "20px",
      // background-color: white;
      boxShadow: " 0 5px 15px rgba(0, 0, 0, 0.3)",
      transition: "top 0.5s ease-in",
      IDBIndex: "1000",
    },
  };

  const options = [];

  if (localStorage.getItem("userTokenname") === "admin") {
    options.push({
      label: (
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={Manager}
            alt="manager-icon"
            style={{ width: "20px", marginRight: "8px" }}
          />
          <FormattedMessage id="Manage Users" />
        </div>
      ),
      value: "manage_users",
    });
  }

  options.push({
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={Logout}
          alt="logout-icon"
          style={{ width: "20px", marginRight: "8px" }}
        />
        <FormattedMessage id="Logout" />
      </div>
    ),
    value: "logout",
  });

  const handleSelect = (option) => {
    if (option.value === "logout") {
      handleLogout();
    } else if (option.value === "manage_users") {
      window.location.href = "/manage";
    }
  };
  const handle = (language) => {
    // let update={language : language};
    const uploadData = new FormData();
    uploadData.append("_method", "PUT");
    localStorage.setItem("language", language);
    uploadData.append("language", language);
    axios
      .post(Source.getAddress() + "/api/settings/1", uploadData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
      })
      .then((res) => {
        dispatch(updateSettingInCache(res.data.settings));
        showAlert({
          position: "top-end",
          icon: "success",
          title: <FormattedMessage id="Language updated successfully!" />,
          showConfirmButton: false,
          timer: 1500,
        });
      })
      .catch((err) => {
        showAlert({
          position: "top-end",
          icon: "error",
          // title: "Something went wrong!",
          title: <FormattedMessage id="Something went wrong!" />,
          showConfirmButton: false,
          timer: 1500,
        });
      });
      window.location.reload();
  };
  return (
    <div>
  <div
    dir={localStorage.getItem("language") === "en" ? "ltr" : "rtl"}
    className="wrapper"
    style={{ backgroundColor: "#ecf0f5", width: "100%", height: "100vh", display: "flex" }}
  >
        <div style={{
          width: localStorage.getItem('toggle')==='true' ? "64px" : window.innerWidth > 768 ? '240px': '0px' ,
          height: "100vh",
          backgroundColor: "#343a40",
          transition: "width 0.3s ease",
          flexShrink: 0,
          overflow: "auto"
        }}>
          <Sidebar isToggled={localStorage.getItem('toggle')==='true'} handleToggle={handleToggle} />
        </div>
    <section 
      id="content" 
      style={{ 
        flex: 1,
        height: "100vh",
        backgroundColor: "#ecf0f5",
        overflow: "auto"
      }}
    >
      <nav style={{ padding: "10px", display: "flex", alignItems: "center" }}>
        <button
          className="btn p-0 m-0 d-flex"
          onClick={() => handleToggle()}
          id="sidebar-toggle"
          type="button"
        >
          <img src={Menu} style={{ width: "30px" }} className="p-0 m-0" />
        </button>
        <a href="#" className="nav-link">
        </a>
        <div className="form-input w-100"></div>
        {/* <input type="checkbox" id="switch-mode" hidden /> */}
        {/* <label htmlFor="switch-mode" className="switch-mode"></label> */}
        <a href="#" className="notification">
          {/* <i className="bx bxs-bell"></i>
          <span className="num">8</span> */}
        </a>
        {/* <a href="#" className="profile">
          <img src="img/people.png" alt="profile" />
        </a> */}
        <div className="btn-group">
  <button
    type="button"
    className={localStorage.getItem('language')==='en' ? 'btn dropdown-toggle fw-bold ' : 'afgFont btn dropdown-toggle fw-bold '}
    // className="btn dropdown-toggle fw-bold text-white"
    data-bs-toggle="dropdown"
    data-bs-display="static"
    aria-expanded="false"
    style={{ padding: "0rem", margin: "0rem", width: "80px" ,color:'#4d859c'}}
  >
    {localStorage.getItem("language") === "en" ? (
      <img src={en} style={{ width: "40%", height: "80%" }} alt="English" />
    ) : (
      <img src={af} style={{ width: "40%", height: "80%" }} alt="Afghan" />
    )}
    <FormattedMessage
      id={
        localStorage.getItem("language") === "en"
          ? "English"
          : localStorage.getItem("language") === "pa"
          ? "Pashto"
          : "Dari"
      }
    />
  </button>
  <ul
    className="dropdown-menu dropdown-menu-lg-end border-1"
    dir={localStorage.getItem("language") === "en" ? "ltr" : "rtl"}
  >
    <li className={localStorage.getItem('language')==='en' ? '' : 'afgFont'}>
      <button
        className="dropdown-item fw-bold d-flex justify-content-between align-items-center"
        type="button"
        onClick={() => {
          handle("en");
        }}
      >
        <FormattedMessage id="English" />
        <img
          src={en}
          style={{ width: "40%", height: "80%", margin: "0.5rem" }}
          alt="English"
        />
      </button>
    </li>
    <li>
      <button
        className="dropdown-item fw-bold d-flex justify-content-between align-items-center"
        type="button"
        onClick={() => {
          handle("da");
        }}
      >
        <FormattedMessage id="Dari" />
        <img
          src={af}
          style={{ width: "40%", height: "80%", margin: "0.5rem" }}
          alt="Afghan"
        />
      </button>
    </li>
    <li>
      <button
        className="dropdown-item fw-bold d-flex justify-content-between align-items-center"
        type="button"
        onClick={() => {
          handle("pa");
        }}
      >
        <FormattedMessage id="Pashto" />
        <img
          src={af}
          style={{ width: "40%", height: "80%", margin: "0.5rem" }}
          alt="Afghan"
        />
      </button>
    </li>
  </ul>
</div><div
              style={{
                position: "relative",
                display: "inline-block",
                marginLeft:
                  localStorage.getItem("language") === "en" ? "auto" : "0", // انتقال به سمت راست در حالت rtl
                marginRight:
                  localStorage.getItem("language") === "en" ? "0" : "auto", // انتقال به سمت چپ در حالت ltr
              }}
            >
              <Dropdown
                options={options}
                onChange={handleSelect}
                placeholder={
                  <div style={{ display: "flex",margin:"0px", alignItems: "center", border:'none!important',color:'#4d859c' }} dir="ltr" className={localStorage.getItem('language')==='en' ? '' : 'afgFont'}>
                    {localStorage.getItem("userToken")}
                    <img
                      src={Accountp}
                      className="p-1 rounded-5"
                      style={{
                        width: "2.5em",
                        marginLeft:
                          localStorage.getItem("language") === "en"
                            ? "8px"
                            : "0", // تنظیم فاصله بر اساس زبان
                        marginRight:
                          localStorage.getItem("language") === "en"
                            ? "0"
                            : "8px", // تنظیم فاصله بر اساس زبان
                      }}
                      alt="User"
                    />
                  </div>
                }
                // className="custom-dropdown"
                className={localStorage.getItem('language')==='en' ? 'custom-dropdown' : 'afgFont custom-dropdown'}
                style={{border:'none!important'}}
              />
            </div>
      </nav>
      
      <div style={{ backgroundColor: "#ecf0f5", padding: "20px" }}>
        {Component}
      </div>
    </section>

    {/* نمایش سایدبار فارسی (اگر زبان انگلیسی نیست)
    {(localStorage.getItem("language") === "da" ||
      localStorage.getItem("language") === "pa") && (
      <div style={{
        width: isToggled ? "64px" : "240px",
        height: "100vh",
        backgroundColor: "#343a40",
        transition: "width 0.3s ease",
        flexShrink: 0,
        overflow: "auto"
      }}>
        <SidebarPa isToggled={isToggled} setIsToggled={setIsToggled} />
      </div>
    )} */}
  </div>
</div>
  );
}
export default App1;
